// «Настройки проекта» (владелец 2026-10-17: «где задать дату начала, праздники, где удалить проект»):
// окно по ⚙ рядом со списком проектов. Название, старт проекта, праздники в сроках проекта (обновить),
// удаление — администратору, с вводом названия (сервер сверяет confirm). Старт и праздники раньше жили
// на экране «Общее» (вкладка «Отчёты») — перенесены сюда, чтобы место было одно.
import { useEffect, useState } from 'react';
import { call, p, type Data } from './api';
import { Pop, type Anchor } from './Pop';
import { fmt, parseDate } from './util';

type Project = Data<'/api/projects', 'get'>[number];
type Prazdniki = Data<'/api/projects/{pid}/prazdniki', 'get'>;
const DNI = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];

export function ProektNastrojki({ proekt, at, mozhnoPravit, mozhnoUdalit, onClose, onIzmenen, onUdalen }: {
  proekt: Project; at: Anchor; mozhnoPravit: boolean; mozhnoUdalit: boolean;
  onClose: () => void; onIzmenen: (msg: string) => void; onUdalen: (msg: string) => void;
}) {
  const pid = proekt.id;
  const global = proekt.code === 'global';
  const [imya, setImya] = useState(proekt.name);
  const [start, setStart] = useState(proekt.start ? fmt(proekt.start) : '');
  const [prazdniki, setPrazdniki] = useState<Prazdniki | null>(null);
  const [gruzim, setGruzim] = useState(false);
  const [udalyaem, setUdalyaem] = useState(false);
  const [podtv, setPodtv] = useState('');
  const [note, setNote] = useState('');

  useEffect(() => {
    let zhiv = true;
    void call<Prazdniki>('get', p('/api/projects/{pid}/prazdniki', { pid })).then(r => { if (zhiv && r.ok) setPrazdniki(r.data); });
    return () => { zhiv = false; };
  }, [pid]);

  async function sohranit() {
    const body: Record<string, unknown> = {};
    if (!global && imya.trim() !== proekt.name) body.name = imya.trim();
    const iso = start.trim() === '' ? null : parseDate(start);
    if (iso === undefined) { setNote('Дата старта не разобрана: нужно ДД.ММ.ГГГГ'); return; }
    if ((iso || null) !== (proekt.start || null)) body.data_starta = iso;
    if (!Object.keys(body).length) { onClose(); return; }
    const r = await call('patch', p('/api/projects/{pid}', { pid }), body);
    if (!r.ok) { setNote(r.error.message); return; }
    onIzmenen('Настройки проекта сохранены' + ('data_starta' in body ? '. Нажмите «Пересчитать» в «Планировании», чтобы обновить даты.' : '.'));
  }
  async function obnovitPrazdniki() {
    setGruzim(true);
    const r = await call<Prazdniki>('post', p('/api/projects/{pid}/prazdniki/obnovit', { pid }), {});
    setGruzim(false);
    if (!r.ok) { setNote(r.error.message); return; }
    setPrazdniki(r.data);
    const tk = r.data.gody.filter(g => g.istochnik === 'tk').map(g => g.god);
    setNote('Праздники обновлены' + (tk.length ? '. На ' + tk.join(', ') + ' постановления ещё нет — по Трудовому кодексу' : ''));
  }
  async function udalit() {
    const r = await call<{ name: string }>('delete', p('/api/projects/{pid}', { pid }), { confirm: podtv.trim() });
    if (!r.ok) { setNote(r.error.message); return; }
    onUdalen('Проект «' + proekt.name + '» удалён.');
  }
  const dd = (x?: string | null) => (x ? fmt(x) : '—');

  return (
    <Pop at={at} title="Настройки проекта" onClose={onClose} width={520}>
      <div className="pn-grid">
        <span>Название</span>
        <input value={imya} maxLength={100} disabled={!mozhnoPravit || global} onChange={e => setImya(e.target.value)}
          title={global ? 'Общий справочник не переименовывается' : undefined} />
        <span title="Раньше этой даты не начинается ни одна задача">Старт проекта</span>
        <input value={start} placeholder="ДД.ММ.ГГГГ" disabled={!mozhnoPravit} style={{ width: 140 }} onChange={e => setStart(e.target.value)} />
      </div>
      {mozhnoPravit && <div className="bar" style={{ margin: '8px 0 4px' }}>
        <button onClick={() => void sohranit()}>Сохранить</button>
      </div>}

      {!global && <>
        <div className="pn-zag">
          <span>Праздники в сроках проекта</span>
          {prazdniki?.s && <span className="pw-muted">{dd(prazdniki.s)} — {dd(prazdniki.po)}</span>}
          {mozhnoPravit && <button className="sec" disabled={gruzim} onClick={() => void obnovitPrazdniki()}
            title="Перезапросить производственный календарь — например, когда вышло постановление на следующий год">
            {gruzim ? 'Загружаю…' : 'Обновить праздники'}</button>}
        </div>
        {!prazdniki ? <div className="pw-muted">Загрузка…</div>
          : !prazdniki.s ? <div className="pw-muted">У проекта нет дат: задайте старт или пересчитайте модель.</div>
            : !prazdniki.stroki.length ? <div className="pw-muted">Праздников в сроках проекта нет.</div>
              : <div className="pn-prazd"><table className="pw-table"><tbody>{prazdniki.stroki.map(x => (
                  <tr key={x.data}><td className="num">{dd(x.data)}</td><td className="num">{DNI[new Date(x.data + 'T00:00:00Z').getUTCDay()]}</td><td>{x.nazvanie}</td></tr>))}
                </tbody></table></div>}
        <div className="pw-muted pn-pod">Праздники учитываются в сроках работ с календарём «Без праздников» (карточка работы).</div>
      </>}

      {mozhnoUdalit && !global && !['sb3', 'p3'].includes(proekt.code) && <div className="pn-udal">
        {!udalyaem
          ? <button className="del" onClick={() => setUdalyaem(true)}>Удалить проект…</button>
          : <>
            <div>Проект удалится со всеми корпусами, работами, задачами и фактом. Вернуть будет нельзя.
              Введите название проекта: <b>{proekt.name}</b></div>
            <div className="bar" style={{ margin: '6px 0 0' }}>
              <input value={podtv} placeholder="название проекта" onChange={e => setPodtv(e.target.value)} style={{ flex: 1 }} />
              <button className="del" disabled={podtv.trim() !== proekt.name} onClick={() => void udalit()}>Удалить навсегда</button>
              <button className="sec" onClick={() => { setUdalyaem(false); setPodtv(''); }}>Отмена</button>
            </div>
          </>}
      </div>}
      {note && <div className="pn-note">{note}</div>}
    </Pop>
  );
}
